/* eslint-disable react/jsx-no-target-blank */
// ** Next Import
import Image from 'next/image'

import React from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'

// ** Icons Imports
import EmailArrowRightOutline from 'mdi-material-ui/EmailArrowRightOutline'

const ParagraphTagServerItem = ({ children }) => {
  return <span style={{ marginTop: '1rem', marginBottom: '1rem' }}>{children}</span>
}

// eslint-disable-next-line no-unused-vars
export default function Policy(props) {
  //  State
  const websiteURL = 'https://ielts-song-ngu.com/'
  const companyName = 'IELTS ꌗⓞNG NGỮ'

  return (
    <Card>
      <Container maxWidth='lg'>
        <Box py={8} px={4}>
          <Typography variant='h4' component='h2' gutterBottom={true}>
            <Typography variant='h4' component='span' color='primary'>
              {'Privacy Policy'}
            </Typography>
          </Typography>
          <Typography
            sx={{
              fontStyle: 'italic'
            }}
            variant='subtitle1'
            color='textSecondary'
            paragraph={true}
          >
            {'Updated at 30-04-2023'}
          </Typography>

          <ParagraphTagServerItem>
            {`${companyName} ("chúng tôi", "của chúng tôi" hoặc "của chúng ta") cam kết bảo vệ quyền riêng tư của bạn. Chính
            sách bảo mật này giải thích cách thông tin cá nhân của bạn được thu thập, sử dụng và tiết lộ bởi ${companyName}.`}
          </ParagraphTagServerItem>

          <ParagraphTagServerItem>
            {`Chính sách bảo mật này áp dụng cho trang web của chúng tôi và các phân miền liên quan (tổng thể là dịch vụ
            của chúng tôi) cùng với ứng dụng của chúng tôi, ${companyName}. Bằng cách truy cập hoặc sử dụng Dịch vụ của
            chúng tôi, bạn cho biết rằng bạn đã đọc, hiểu và đồng ý với việc thu thập, lưu trữ, sử dụng và tiết lộ thông
            tin cá nhân của bạn như được mô tả trong Chính sách bảo mật này và Điều khoản dịch vụ của chúng tôi.`}
          </ParagraphTagServerItem>

          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Definitions and key terms'}
          </Typography>
          <ParagraphTagServerItem>
            Để giải thích mọi thứ một cách rõ ràng nhất có thể trong Chính sách bảo mật này, mỗi khi bất kỳ thuật ngữ
            nào được đề cập, chúng sẽ được định nghĩa chặt chẽ như sau:
          </ParagraphTagServerItem>

          <ul>
            <li>
              Cookie: một lượng nhỏ dữ liệu được tạo ra bởi một trang web và được lưu trữ bởi trình duyệt web của bạn.
              Nó được sử dụng để xác định trình duyệt của bạn, cung cấp phân tích dữ liệu, ghi nhớ thông tin về bạn như
              ngôn ngữ hoặc thông tin đăng nhập.
            </li>
            <li>
              {`Khách hàng: đề cập đến công ty, tổ chức hoặc cá nhân đăng ký để sử dụng Dịch vụ ${companyName} để quản lý mối
              quan hệ với khách hàng hoặc người sử dụng dịch vụ.`}
            </li>
            <li>
              {`Thiết bị: bất kỳ thiết bị kết nối internet nào như điện thoại, máy tính bảng, máy tính hoặc bất kỳ thiết
              bị nào khác có thể được sử dụng để truy cập ${companyName} và sử dụng dịch vụ.`}
            </li>
            <li>
              Mỗi thiết bị kết nối với Internet đều được gán một số gọi là địa chỉ giao thức Internet (IP). Những số này
              thường được gán thành các khối địa lý. Một địa chỉ IP thường có thể được sử dụng để xác định vị trí mà
              thiết bị đó kết nối với Internet.
            </li>
            <li>
              Dữ liệu cá nhân: bất kỳ thông tin nào trực tiếp, gián tiếp hoặc liên quan đến thông tin khác - bao gồm số
              nhận dạng cá nhân - cho phép xác định hoặc có thể xác định được một cá nhân tự nhiên.
            </li>
            <li>
              {`Service: refers to the service provided by ${companyName} as described in the relative terms (if available)
              and on this platform. -Third-party service: refers to advertisers, contest sponsors, promotional and
              marketing partners, and others who provide our content or whose products or services we think may interest
              you. -Website: ${companyName}.”’s” site, which can be accessed via this URL: ${websiteURL} -You: a
              person or entity that is registered with ${companyName} to use the Services.`}
            </li>
            <li>
              Third-party service: được định nghĩa là các nhà quảng cáo, nhà tài trợ cuộc thi, đối tác quảng bá và
              marketing và những người cung cấp nội dung hoặc sản phẩm và dịch vụ mà chúng tôi nghĩ rằng có thể gây hứng
              thú cho bạn.
            </li>
            <li>{`Website: trang web của ${companyName}, có thể truy cập thông qua URL này: ${websiteURL}.`}</li>
          </ul>

          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Information automatically collected-'}
          </Typography>
          <ParagraphTagServerItem>
            Khi bạn truy cập vào nền tảng của chúng tôi, một số thông tin như địa chỉ Protocol Internet (IP) và/hoặc đặc
            tính trình duyệt và thiết bị sẽ tự động được thu thập. Thông tin này có thể được sử dụng để kết nối máy tính
            của bạn với Internet. Thông tin khác được tự động thu thập có thể là tên đăng nhập, địa chỉ email, mật khẩu,
            thông tin về máy tính và kết nối như loại và phiên bản plug-in trình duyệt và cài đặt múi giờ, hệ điều hành
            và nền tảng, lịch sử mua hàng (đôi khi được tổng hợp với thông tin tương tự từ người dùng khác), địa chỉ đầy
            đủ của Định vị tài nguyên thống nhất (URL) trên trang web mà có thể bao gồm ngày và giờ; số cookie; các phần
            của trang web bạn đã xem hoặc tìm kiếm; và số điện thoại bạn sử dụng để gọi đến Dịch vụ Khách hàng của chúng
            tôi. Chúng tôi cũng có thể sử dụng dữ liệu trình duyệt như cookie, Flash cookie (còn được gọi là Flash Local
            Shared Objects) hoặc dữ liệu tương tự trên một số phần của trang web của chúng tôi để ngăn chặn gian lận và
            cho các mục đích khác. Trong quá trình truy cập, chúng tôi có thể sử dụng các công cụ phần mềm như
            JavaScript để đo lường và thu thập thông tin phiên bao gồm thời gian phản hồi trang, lỗi tải xuống, thời
            gian truy cập vào các trang cụ thể, thông tin tương tác trang (như cuộn trang, nhấp chuột và di chuột qua),
            và các phương pháp được sử dụng để điều hướng khỏi trang. Chúng tôi cũng có thể thu thập thông tin kỹ thuật
            để giúp xác định thiết bị của bạn cho mục đích ngăn chặn gian lận và chẩn đoán.
          </ParagraphTagServerItem>
          <ParagraphTagServerItem>
            Khi bạn truy cập, sử dụng hoặc duyệt qua platform của chúng tôi, chúng tôi tự động thu thập một số thông tin
            nhất định. Thông tin này không tiết lộ danh tính cụ thể của bạn (như tên hoặc thông tin liên lạc), nhưng có
            thể bao gồm thông tin thiết bị và sử dụng, chẳng hạn như địa chỉ IP, các đặc điểm trình duyệt và thiết bị,
            hệ điều hành, ngôn ngữ ưa thích, URL trang trỏ về, tên thiết bị, quốc gia, vị trí và thông tin về ai và khi
            nào bạn sử dụng platform của chúng tôi, cùng với các thông tin kỹ thuật khác. Thông tin này chủ yếu được sử
            dụng để duy trì an ninh và hoạt động của platform của chúng tôi, cũng như cho mục đích phân tích và báo cáo
            nội bộ của chúng tôi.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Personnel'}
          </Typography>
          <ParagraphTagServerItem>
            Bạn có thể liên hệ với chúng tôi để (1) cập nhật hoặc sửa thông tin của bạn, (2) thay đổi sở thích của bạn
            liên quan đến thông tin và các thông tin khác mà bạn nhận được từ chúng tôi, hoặc (3) nhận được một bản ghi
            của thông tin chúng tôi có liên quan đến bạn. Những cập nhật, sửa đổi, thay đổi và xóa này sẽ không ảnh
            hưởng đến thông tin khác mà chúng tôi duy trì, hoặc thông tin mà chúng tôi đã cung cấp cho bên thứ ba theo
            Chính sách Bảo mật này trước khi cập nhật, sửa đổi, thay đổi hoặc xóa đó được thực hiện.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Sale of Business'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi có thể tiết lộ thông tin của bạn cho các bên thứ ba như sau:
            <ul>
              <li>Các bên thứ ba mà bạn yêu cầu hoặc cho phép chúng tôi tiết lộ thông tin.</li>
              <li>
                Các bên thứ ba cung cấp dịch vụ cho chúng tôi, chẳng hạn như dịch vụ lưu trữ, xử lý thanh toán, quảng
                cáo, phân tích dữ liệu, dịch vụ khách hàng và các công ty khác cung cấp cho chúng tôi các sản phẩm hoặc
                dịch vụ liên quan đến việc cung cấp dịch vụ của chúng tôi.{' '}
              </li>
              <li>
                {`Bất kỳ bên thứ ba nào mà chúng tôi cho rằng cần thiết hoặc thích hợp để tuân thủ các luật pháp, quy
                định, yêu cầu pháp lý hoặc quy trình pháp lý hợp lý hoặc để bảo vệ quyền lợi, tài sản hoặc an ninh của
                ${companyName} hoặc bất kỳ bên thứ ba nào.`}
              </li>
              <li>
                Bất kỳ bên thứ ba nào mà chúng tôi cho rằng là cần thiết hoặc thích hợp để ngăn ngừa hoặc giải quyết các
                hành vi vi phạm các điều khoản sử dụng của chúng tôi hoặc để bảo vệ quyền lợi, tài sản hoặc an ninh của
                chúng tôi hoặc bất kỳ bên thứ ba nào. Chúng tôi sẽ không bán, cho thuê hoặc trao đổi thông tin cá nhân
                của bạn cho bất kỳ bên thứ ba nào với các mục đích tiếp thị hoặc quảng cáo mà không có sự đồng ý của
                bạn.
              </li>
            </ul>
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Affiliates'}
          </Typography>
          <ParagraphTagServerItem>
            {`Chúng tôi có thể tiết lộ thông tin (bao gồm thông tin cá nhân) về bạn cho các Đối tác liên kết của chúng
            tôi. Với mục đích của Chính sách Bảo mật này, "Đối tác liên kết" có nghĩa là bất kỳ cá nhân hoặc tổ chức nào
            trực tiếp hoặc gián tiếp kiểm soát, bị kiểm soát bởi hoặc chung quyền kiểm soát với ${companyName}, cho dù là
            bằng sở hữu hoặc bằng cách khác. Bất kỳ thông tin liên quan đến bạn mà chúng tôi cung cấp cho các Đối tác
            liên kết của chúng tôi sẽ được xử lý bởi những Đối tác liên kết đó theo các điều khoản trong Chính sách Bảo
            mật này.`}
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Your Consent'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi đã cập nhật Chính sách Bảo mật của chúng tôi để cung cấp cho bạn sự minh bạch hoàn chỉnh về những
            gì được thiết lập khi bạn truy cập vào trang web của chúng tôi và cách nó được sử dụng. Bằng cách sử dụng
            trang web / ứng dụng của chúng tôi, đăng ký tài khoản hoặc thực hiện một giao dịch mua hàng, bạn đồng ý với
            Chính sách Bảo mật của chúng tôi và đồng ý với các điều khoản của nó.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Links to Other Websites'}
          </Typography>
          <ParagraphTagServerItem>
            {`Chính sách bảo mật này chỉ áp dụng cho Dịch vụ của chúng tôi. Dịch vụ có thể chứa liên kết đến các trang web
            khác không được vận hành hoặc kiểm soát bởi ${companyName}. Chúng tôi không chịu trách nhiệm về nội dung, độ
            chính xác hoặc quan điểm được thể hiện trên các trang web đó, và các trang web đó không được điều tra, giám
            sát hoặc kiểm tra độ chính xác hoặc đầy đủ bởi chúng tôi. Vui lòng nhớ rằng khi bạn sử dụng một liên kết để
            đi từ Dịch vụ đến một trang web khác, Chính sách bảo mật của chúng tôi sẽ không còn có hiệu lực. Việc duyệt
            và tương tác trên bất kỳ trang web nào khác, bao gồm những trang web có liên kết trên nền tảng của chúng
            tôi, đều phải tuân theo các quy tắc và chính sách riêng của trang web đó. Những bên thứ ba này có thể sử
            dụng cookie hoặc các phương pháp khác để thu thập thông tin về bạn.`}
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Cookies'}
          </Typography>
          <ParagraphTagServerItem>
            {`${companyName} sử dụng "Cookie" để xác định các khu vực của trang web mà bạn đã truy cập. Một Cookie là một mảnh
            dữ liệu nhỏ được lưu trữ trên máy tính hoặc thiết bị di động của bạn bởi trình duyệt web của bạn. Chúng tôi
            sử dụng Cookie để tăng cường hiệu suất và chức năng của trang web / ứng dụng của chúng tôi, nhưng không bắt
            buộc cho việc sử dụng trang web / ứng dụng của chúng tôi. Tuy nhiên, nếu không có các cookie này, một số
            chức năng như video có thể trở nên không khả dụng hoặc bạn sẽ được yêu cầu nhập thông tin đăng nhập của bạn
            mỗi khi bạn truy cập trang web / ứng dụng vì chúng tôi sẽ không thể nhớ rằng bạn đã đăng nhập trước đó. Hầu
            hết các trình duyệt web có thể được thiết lập để vô hiệu hóa việc sử dụng Cookies. Tuy nhiên, nếu bạn vô
            hiệu hóa Cookies, bạn có thể không thể truy cập chức năng trên trang web của chúng tôi đúng cách hoặc hoàn
            toàn không thể truy cập được. Chúng tôi không bao giờ đặt Thông tin nhận dạng cá nhân trong Cookies.`}
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Remarketing Services'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi sử dụng dịch vụ remarketing. Remarketing là gì? Trong marketing số, remarketing (hoặc retargeting)
            là thực hành hiển thị quảng cáo trên internet đến những người đã ghé thăm trang web của bạn. Nó cho phép
            công ty của bạn trông như đang "theo dõi" người dùng trên internet bằng cách hiển thị quảng cáo trên các
            trang web và nền tảng mà họ sử dụng nhiều nhất.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Kids’ Privacy'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi không đối tượng đến bất kỳ ai dưới 13 tuổi. Chúng tôi không thu thập thông tin cá nhân có thể xác
            định được từ bất kỳ ai dưới 13 tuổi. Nếu bạn là cha mẹ hoặc người giám hộ và nhận thấy rằng con của bạn đã
            cung cấp cho chúng tôi dữ liệu cá nhân, vui lòng liên hệ với chúng tôi. Nếu chúng tôi nhận ra rằng chúng tôi
            đã thu thập dữ liệu cá nhân từ bất kỳ ai dưới 13 tuổi mà không được xác nhận bởi sự đồng ý của phụ huynh,
            chúng tôi sẽ thực hiện các bước để loại bỏ thông tin đó khỏi máy chủ của chúng tôi.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Changes To Our Privacy Policy'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi có thể thay đổi Dịch vụ và các chính sách của chúng tôi, và có thể cần phải thay đổi Chính sách
            Bảo mật này để phản ánh chính xác Dịch vụ và chính sách của chúng tôi. Trừ khi yêu cầu khác theo luật, chúng
            tôi sẽ thông báo cho bạn (ví dụ, thông qua Dịch vụ của chúng tôi) trước khi chúng tôi thực hiện thay đổi
            Chính sách Bảo mật này và cho bạn cơ hội xem xét chúng trước khi chúng có hiệu lực. Sau đó, nếu bạn tiếp tục
            sử dụng Dịch vụ, bạn sẽ bị ràng buộc bởi Chính sách Bảo mật được cập nhật. Nếu bạn không đồng ý với Chính
            sách Bảo mật này hoặc bất kỳ Chính sách Bảo mật được cập nhật nào, bạn có thể xóa tài khoản của mình.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Third-Party Services'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi có thể hiển thị, bao gồm hoặc cung cấp nội dung của bên thứ ba (bao gồm dữ liệu, thông tin, ứng
            dụng và các sản phẩm dịch vụ khác) hoặc cung cấp liên kết đến các trang web hoặc dịch vụ của bên thứ ba
            ("Dịch vụ bên thứ ba").
            <br />{' '}
            {`Bạn thừa nhận và đồng ý rằng ${companyName} không chịu trách nhiệm cho bất kỳ Dịch vụ bên thứ ba nào, bao
            gồm tính chính xác, đầy đủ, kịp thời, hợp lệ, tuân thủ bản quyền, hợp pháp, độ lịch sự, chất lượng hoặc bất
            kỳ khía cạnh nào khác của chúng. ${companyName} không có trách nhiệm và sẽ không chịu trách nhiệm đối với bạn
            hoặc bất kỳ cá nhân hoặc tổ chức nào khác đối với bất kỳ Dịch vụ bên thứ ba nào.`}
            <br />
            Dịch vụ bên thứ ba và liên kết đến chúng được cung cấp hoàn toàn để thuận tiện cho bạn và bạn truy cập và sử
            dụng chúng hoàn toàn trên sự đồng ý và rủi ro của bạn và phải tuân thủ các điều khoản và điều kiện của bên
            thứ ba đó.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Tracking Technologies'}
          </Typography>
          <ParagraphTagServerItem>
            <ul>
              <li>
                <ParagraphTagServerItem>Cookies</ParagraphTagServerItem>
                <ParagraphTagServerItem>
                  Chúng tôi sử dụng Cookies để cải thiện hiệu suất và chức năng của trang web / ứng dụng của chúng tôi
                  nhưng không bắt buộc để sử dụng. Tuy nhiên, nếu không có cookies này, một số chức năng như xem video
                  có thể không khả dụng hoặc bạn sẽ được yêu cầu nhập thông tin đăng nhập mỗi khi truy cập vào trang web
                  / ứng dụng vì chúng tôi sẽ không thể nhớ rằng bạn đã đăng nhập trước đó.
                </ParagraphTagServerItem>
              </li>
              <li>
                <ParagraphTagServerItem>Local Storage</ParagraphTagServerItem>
                <ParagraphTagServerItem>
                  Local Storage đôi khi được gọi là DOM storage, cung cấp cho ứng dụng web các phương pháp và giao thức
                  để lưu trữ dữ liệu phía máy khách. Web storage hỗ trợ lưu trữ dữ liệu bền vững, tương tự như cookies
                  nhưng với khả năng lưu trữ tăng cường đáng kể và không có thông tin được lưu trữ trong tiêu đề yêu cầu
                  HTTP.
                </ParagraphTagServerItem>
              </li>
            </ul>
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Information about General Data Protection Regulation (GDPR)'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi có thể thu thập và sử dụng thông tin từ bạn nếu bạn đến từ Khu vực Kinh tế châu Âu (EEA), và trong
            phần này của Chính sách bảo mật của chúng tôi, chúng tôi sẽ giải thích chính xác cách và tại sao dữ liệu này
            được thu thập, và cách chúng tôi bảo vệ dữ liệu này khỏi việc sao chép hoặc sử dụng sai cách.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'What is personal data?'}
          </Typography>
          <ParagraphTagServerItem>
            Dữ liệu cá nhân là bất kỳ dữ liệu nào liên quan đến một cá nhân có thể được xác định hoặc đã được xác định.
            GDPR bao gồm một phạm vi rộng lớn các thông tin có thể được sử dụng độc lập, hoặc kết hợp với các thông tin
            khác, để xác định một cá nhân. Dữ liệu cá nhân vượt xa tên hoặc địa chỉ email của một người. Một số ví dụ
            bao gồm thông tin tài chính, quan điểm chính trị, dữ liệu di truyền, dữ liệu sinh trắc học, địa chỉ IP, địa
            chỉ vật lý, định hướng tình dục và sắc tộc.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'The Data Protection Principles include requirements such as:'}
          </Typography>
          <ParagraphTagServerItem>
            <ul>
              <li>
                Các dữ liệu cá nhân được thu thập phải được xử lý một cách công bằng, hợp pháp và minh bạch và chỉ nên
                được sử dụng một cách hợp lý mà người đó có thể hi vọng.
              </li>{' '}
              <li>
                Dữ liệu cá nhân chỉ nên được thu thập để đáp ứng một mục đích cụ thể và chỉ nên được sử dụng cho mục
                đích đó.
              </li>{' '}
              <li>Tổ chức phải xác định lý do tại sao họ cần dữ liệu cá nhân khi thu thập nó.</li>{' '}
              <li>Dữ liệu cá nhân không được giữ quá lâu so với mục đích sử dụng của nó.</li>{' '}
              <li>Người được bảo vệ theo GDPR có quyền truy cập vào dữ liệu cá nhân của chính họ.</li>{' '}
              <li>
                Họ cũng có thể yêu cầu một bản sao của dữ liệu của mình và yêu cầu cập nhật, xóa, hạn chế hoặc chuyển dữ
                liệu của mình đến tổ chức khác.
              </li>
            </ul>
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Individual Data Subject’s Rights – Data Access, Portability and Deletion'}
          </Typography>
          <ParagraphTagServerItem>
            Chúng tôi cam kết hỗ trợ khách hàng của mình đáp ứng các yêu cầu về quyền dữ liệu cá nhân của GDPR. Halal
            MUI xử lý hoặc lưu trữ tất cả các dữ liệu cá nhân trên các nhà cung cấp đã được kiểm tra đầy đủ và tuân thủ
            DPA. Chúng tôi lưu trữ tất cả các cuộc trò chuyện và dữ liệu cá nhân trong vòng 6 năm trừ khi tài khoản của
            bạn bị xóa. Trong trường hợp đó, chúng tôi sẽ xóa toàn bộ dữ liệu theo Điều khoản Dịch vụ và Chính sách bảo
            mật của chúng tôi, nhưng sẽ không giữ nó lâu hơn 60 ngày.
          </ParagraphTagServerItem>
          <ParagraphTagServerItem>
            Chúng tôi nhận thức rằng nếu bạn đang làm việc với khách hàng EU, bạn cần cung cấp cho họ khả năng truy cập,
            cập nhật, khôi phục và xóa dữ liệu cá nhân. Chúng tôi sẵn sàng hỗ trợ bạn! Chúng tôi đã được thiết lập để tự
            phục vụ từ đầu và luôn cung cấp cho bạn quyền truy cập vào dữ liệu của mình và dữ liệu của khách hàng của
            bạn. Đội ngũ hỗ trợ khách hàng của chúng tôi sẵn sàng giải đáp bất kỳ câu hỏi nào bạn có về việc làm việc
            với API.
          </ParagraphTagServerItem>
          <Typography variant='h6' component='h6' sx={{ width: '100%', fontWeight: 'bold' }} gutterBottom={true}>
            {'Contact Us'}
          </Typography>
          <ParagraphTagServerItem>
            Đừng ngần ngại liên hệ với chúng tôi nếu bạn có bất kỳ câu hỏi nào
          </ParagraphTagServerItem>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <EmailArrowRightOutline />
            <Box
              component='a'
              target='_blank'
              rel='origin'
              href={'mailto: ieltssongngu@gmail.com'}
              sx={{
                textDecoration: 'none',
                color: 'primary.main'
              }}
            >
              <Typography variant='body' sx={{ marginBottom: 0, marginLeft: 2 }}>
                ieltssongngu@gmail.com
              </Typography>
            </Box>
          </Box>
          {/* <Divider sx={{ marginTop: 2, marginBottom: 2 }} /> */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 2,
              marginBottom: 2
            }}
          >
            <Image src={'/images/app/ic_facebook.png'} alt={'facebook'} width={24} height={24} />
            <Box
              component='a'
              target='_blank'
              rel='origin'
              href={'https://www.facebook.com/web.hocngoainguhieuqua'}
              sx={{
                textDecoration: 'none',
                color: 'primary.main'
              }}
            >
              <Typography variant='body' sx={{ marginBottom: 0, marginLeft: 2 }}>
                fb.com/web.hocngoainguhieuqua
              </Typography>
            </Box>
          </Box>
          {/* <Divider sx={{ marginTop: 2, marginBottom: 2 }} /> */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 2,
              marginBottom: 2
            }}
          >
            <Image src={'/images/app/ic_zalo.png'} alt={'zalo'} width={24} height={24} />
            <Box
              component='a'
              target='_blank'
              rel='origin'
              href={'https://chat.zalo.me/?phone=0395608813'}
              sx={{
                textDecoration: 'none',
                color: 'primary.main'
              }}
            >
              <Typography variant='body' sx={{ marginBottom: 0, marginLeft: 2 }}>
                {'0395608813'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Card>
  )
}
